<template>
  <inventoryCategoriesList/>
</template>
<script>
import inventoryCategoriesList from '@/components/modules/papeleria/products/subcategories/list'
export default {
  name: 'inventoryCategories',
  components: {
    inventoryCategoriesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/products/subcategories/list.vue